import { Elevation3 } from '@services/mantine';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: 16px;

  box-shadow: ${Elevation3.boxShadow};
  border: none;
  border-radius: ${Elevation3.borderRadius}px;
  padding: 12px 16px 24px;
  width: min(320px, 70vw);

  max-height: 70vh;
`;

export const ButtonGroup = styled.div`
  padding-top: 8px;
  display: flex;
  width: 100%;
  justify-content: flex-end;

  column-gap: 8px;
`;

export const HeaderGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FilterOptions = styled.div`
  overflow: auto;
  overflow-x: hidden;
`;
